import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface countryState {
    data: {} | null | any;
    getAllCountry: null;
    totalRecords: number | null;
    totalPages: number | null;
    currentPage: number | null;
}

const initialState: countryState = {
    data: null,
    getAllCountry: null,
    totalRecords: null,
    totalPages: null,
    currentPage: null,
};

export const countrySlice = createSlice({
    name: 'country',
    initialState,
    reducers: {
        setcountry: (state, action) => {
            state.data = action.payload.data;
        },
        setAllCountriesWithPagination: (state, action) => {
            console.log(state, "state");
            state.data = action.payload.data.data;
            state.totalRecords = action.payload.data.totalRecords;
            state.totalPages = action.payload.data.totalPage;
            state.currentPage = action.payload.data.currentPage;
        },
        setCountryBySearch: (state, action) => {
            state.data = action.payload.data.data;
            state.totalRecords = action.payload.data.totalRecords;
            state.totalPages = action.payload.data.totalPage;
            state.currentPage = action.payload.data.currentPage;
        },
        addNewcountry: (state: any, action) => {
            state.data = [action.payload, ...state.data];
        },
        reset: (state) => {
            state = initialState;
        },
    },
});

// Action creators are generated for each case reducer function
export const { setcountry, addNewcountry, setAllCountriesWithPagination, setCountryBySearch ,reset, } = countrySlice.actions;
export const getAllcountryDetail = (state: RootState) => state.country.data;
export const getAllCountryTotalRecords = (state: RootState) =>
    state.country.totalRecords;
export const getAllCountryWithPaginationDetails = (state: RootState) =>
    state.country.data;
export const getCountrySearch = (state: RootState) =>
  state.country.data;
export default countrySlice.reducer;

